import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore, YA_CAPTCHA_ENABLED } from 'vpl.tas';
import { initYaCaptcha, ymLead } from 'vpl.tas';
import { NewsletterCheckbox } from 'vpl.tas';

export const RequestModal = {
    components: { NewsletterCheckbox },
    props: {
        structKey: [String, Number]
    },
    data(){
        return {
          captcha: false,
          yatoken: ''
        }
      },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH', 'YA_CLIENT_KEY', 'captchaInited', 'templateData'])
    },
    methods: {
        execCaptcha(){
            vplSiteStore.capresolved = true;
            this.sendForm();
        },
        sendForm(){
            let form = $(this.$el).find('form'),
                form_data = new FormData();

            $.each($("input,textarea,button,select", form), function () {
                if ($(this).attr("type") == "checkbox") {
                    if ($(this).prop("checked")) {
                        form_data.append($(this).attr("name"), true);
                    }
                } else if ($(this).attr("type") == "radio") {
                    if ($(this).prop("checked")) {
                        form_data.append($(this).attr("name"), $(this).val());
                    }
                } else if ($(this).attr("type") == "file") {
                    if ($(this).prop("files").length) {
                        form_data.append($(this).attr("name"), $(this).prop("files")[0]);
                    }
                }else if (
                    $(this).attr("name") !== undefined &&
                    $(this).attr("name").length
                ) {
                    form_data.append($(this).attr("name"), $(this).val());
                }
            });

            form_data.append('WEB_FORM_ID', 2);
            form_data.append('web_form_submit', 'y');
            form_data.append('sessid', BX.bitrix_sessid());
            form_data.append('url', window.location.href); //урл для согласия
            form_data.append('form_text_29', window.location.href); //страница отправки

            form_data.append('smart-token', this.yatoken);

            if(vplSiteStore.capresolved){
                form_data.append('skip-captcha', 'Y');
            }

            $.ajax({
                url: '/ajax/form.php',
                dataType: "json",
                cache: false,
                contentType: false,
                processData: false,
                data: form_data,
                type: "post",
                success: (response) => {
                    form.find(".is-error").removeClass("is-error");


                    if (!response.ERRORS || !Object.keys(response.ERRORS).includes("CAPTCHA")) {
                        vplSiteStore.capresolved = true;
                    }

                    if (response.STATUS == "OK") {
                        ymLead('service_request', response);
                        form.find("input[type=text],input[type=email],textarea").val("");

                        if (form.closest(".modal").length) {
                            form.closest(".modal").modal("hide");
                        }

                        $('#success').modal();

                    } else {
                        for (var i in response.ERRORS) {
                            if (i == "CAPTCHA") {
                                form.find(".captcha").addClass("is-error");
                            } else {
                                form
                                    .find("[name=" + i + "]")
                                    .parent()
                                    .addClass("is-error");
                            }
                        }
                    }
                }
            });
        },
        initCaptcha(){

            let self = this;

            initYaCaptcha();

            let interval = setInterval(()=>{
                if(this.captcha === false &&  (!YA_CAPTCHA_ENABLED || typeof window.smartCaptcha !== "undefined") && this.YA_CLIENT_KEY){

                    this.captcha = YA_CAPTCHA_ENABLED && window.smartCaptcha.render($(this.$el).find('.js-captcha')[0], {
                        sitekey: self.YA_CLIENT_KEY,
                        invisible: true,
                        callback: function(token) {
                            window.yaToken = token;
                            self.yatoken = token;
                            self.sendForm();
                        },
                        hideShield: true,
                    });


                new Cleave($(this.$el).find('.js-phone')[0], {
                    numericOnly: true,
                    delimiters: [" (", ") ", "-", "-"],
                    blocks: [1, 3, 3, 2, 2]
                });

                clearInterval(interval);
                }
            }, 500);
        }
    },
    updated(){


    },
    mounted(){

        let self = this;
        if(self.captchaInited){
            self.initCaptcha();
        }else{
            const elem = self.$el;
            new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        self.initCaptcha();
                        observer.unobserve(entry.target);
                    }
                });
            }).observe(elem);
        }


      $(this.$el).find('select').show().niceSelect();

        let dropServiceArea = this.$el.querySelectorAll(".js-field-file");
        for (var i = 0; i < dropServiceArea.length; i++) {
            dropServiceArea[i].addEventListener('dragover', e => {
                e.preventDefault();
            });
            dropServiceArea[i].addEventListener('drop', function(e){
                e.preventDefault();
                const file = e.dataTransfer?.files[0];
                if(file){

                    const fileInput = $(this).find(".js-field-input")[0];
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file);
                    fileInput.files = dataTransfer.files;
                    $(fileInput).trigger('change')
                }
            });
        }
        $(this.$el).find(".js-field-file .js-field-input").change(function(){
            let textElem = $(this).closest('.js-field-file').find('.js-file-description');
            if($(this)[0].files[0]){
                textElem.text($(this)[0].files[0].name)
            }
        });

    },
    template: `
<div class="modal fade modal-fastbuy modal-order hide" id="order"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">Заявка на услугу</div>
          <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">
                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
              </span>
          </button>
      </div>
      <div class="modal-body js-request-modal-form">
        <form @submit.prevent="execCaptcha()">
            <!--
            <div class="form-select">
                <select name="form_dropdown_SIMPLE_QUESTION_966" id="" class="sort__select" style="display: none;">
                    <option value="">Выберите услугу</option>
                        <option v-for="answer in this.struct[this.structKey].componentData.SERVICE" :value="answer.ID" class="">{{answer.MESSAGE}}</option>
                </select>
            </div>
            <div class="form-select">
                <select name="form_dropdown_SIMPLE_QUESTION_418" id="" class="sort__select" style="display: none;">
                    <option value="">Выберите тип объекта</option>
                    <option v-for="answer in this.struct[this.structKey].componentData.OBJECT" :value="answer.ID" class="">{{answer.MESSAGE}}</option>
                </select>
            </div>
            -->

            <div class="field js-material-input is-required" :class="{active: templateData.userName}">
                <input class="field__input" name="form_text_6" id="request-modal-name" autocomplete="off" type="text" :value="templateData.userName">
                <label class="field__label" for="request-modal-name">Имя</label>
                <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input is-required" :class="{active: templateData.userEmail}">
                <input class="field__input" name="form_email_7" id="request-modal-mail" autocomplete="off" type="text" :value="templateData.userEmail">
                <label class="field__label" for="request-modal-mail">Электронная почта</label>
                <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input is-required" :class="{active: templateData.userPhone}">
                <input class="field__input js-phone" name="form_text_8" id="request-modal-tel" autocomplete="off" type="text" :value="templateData.userPhone">
                <label class="field__label" for="request-modal-tel">Телефон</label>
                <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input is-required">
                <textarea class="field__input field__input--textarea" rows="3" name="form_textarea_9" id="modal-text" placeholder="Ваше сообщение" autocomplete="off"></textarea>
                <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field field--file js-field-file">
                <input type="file" class="field__input js-field-input" id="request-modal-sh" name="form_file_83" accept=".jpg,.jpeg,.png,.webp,.gif,.bmp,.tif,.tiff,.pdf,.doc,.docx,.rtf,.txt,.odt,.xls,.xlsx,.xlsm,.csv,.ods,.dwg,.dxf,.dwt,.dws,.stp,.step,.igs,.iges,.ifc,.zip,.rar,.7z" hidden="" autocomplete="off">
                <label class="field__file js-field-label" for="request-modal-sh">
                    <svg class="icon icon-file">
                        <use xlink:href="#icon-file"></use>
                    </svg>
                    <span class="js-file-description">Добавить файл <br>
                        (изображения, PDF, Word, Excel, AutoCAD и архивы)</span>
                </label>
            </div>
            <div class="form__submit">
                <div class="form__submit-container">
                    <div class="captcha">
                        <div class="captcha js-captcha">
                        </div>
                    </div>
                    <button type="submit" name="web_form_submit" value="Y" class="btn btn--green">
                        Отправить
                    </button>
                </div>
                <div class="checkbox">
                    <input type="checkbox" checked name="politic" class="checkbox__input js-politic js-politic-auto" id="politic-request-modal">
                    <label for="politic-request-modal" class="checkbox__label">
                        При нажатии на кнопку «Отправить» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                    </label>
                </div>
                <NewsletterCheckbox />
            </div>
		</form>
      </div>
    </div>
  </div>
</div>
      `
}